import { useState } from 'react'

export default function useModalControl() {
    const [open, setOpen] = useState(false)
    const handleCloseModal = () => {
        setOpen(false)
    }
    const handleOpenModal = () => {
        setOpen(true)
    }
    return { open, handleCloseModal, handleOpenModal, setOpen }
}
